/**
 * Renders SEO landing article sections (H2 + prose + optional bullet list).
 * Content keys live in i18n (e.g. en.js); structure comes from seoLandingConfig sectionBlocks.
 */
import { Fragment, lazy, Suspense } from 'react'

const SeoDiagramLazy = lazy(() => import('./SeoDiagram').then((m) => ({ default: m.SeoDiagram })))

/** @param {{ pageCfg: object, t: (key: string) => string, diagramSpec?: object | null }} props */
export function SeoSectionBlocks({ pageCfg, t, diagramSpec = null }) {
  const blocks = pageCfg?.sectionBlocks
  if (!blocks?.length) return null

  return (
    <>
      {blocks.map((block, idx) => (
        <Fragment key={block.titleKey}>
          <section className="docusign-alt-landing__section">
            <h2 className="docusign-alt-landing__section-title">{t(block.titleKey)}</h2>
            {(block.bodyKeys ?? []).map((bk) => (
              <p
                key={bk}
                className={`docusign-alt-landing__prose${pageCfg.bodyKeysPreline?.includes(bk) ? ' docusign-alt-landing__prose--preline' : ''}`}
              >
                {t(bk)}
              </p>
            ))}
            {(block.bulletKeys ?? []).length ? (
              <ul className="docusign-alt-landing__bullet-list">
                {block.bulletKeys.map((bk) => (
                  <li key={bk}>{t(bk)}</li>
                ))}
              </ul>
            ) : null}
          </section>
          {diagramSpec && diagramSpec.insertAfterBlockIndex === idx ? (
            <Suspense
              fallback={
                <div
                  className="seo-diagram seo-diagram--lazy-fallback"
                  aria-hidden="true"
                />
              }
            >
              <SeoDiagramLazy
                steps={diagramSpec.steps}
                microIntro={diagramSpec.microIntro}
                title={diagramSpec.title}
                description={diagramSpec.description}
                figcaption={diagramSpec.figcaption}
                ariaLabel={diagramSpec.ariaLabel}
              />
            </Suspense>
          ) : null}
        </Fragment>
      ))}
    </>
  )
}
